import { render, staticRenderFns } from "./MatchHeroNav.vue?vue&type=template&id=1d5cc729&scoped=true"
import script from "./MatchHeroNav.vue?vue&type=script&lang=js"
export * from "./MatchHeroNav.vue?vue&type=script&lang=js"
import style0 from "./MatchHeroNav.vue?vue&type=style&index=0&id=1d5cc729&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5cc729",
  null
  
)

export default component.exports